import { instanceAxios } from '../InstanceAxios';

class Enotas {
  async homologationCityStatus(token, ibge) {
    const instance = instanceAxios(token);

    const response = await instance
      .get(`verificarStatusHomologacaoPrefeitura/${ibge}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.log(err);
        return {
          status: 'error',
        };
      });

    return response;
  }

  async validateCityIsApprovedENotas(token, ibge) {
    let status = false;

    try {
      const response = await this.homologationCityStatus(token, ibge);
      if (response.status === 'success') {
        status = response.message.includes('Não homologada');
      }
    } catch (err) {
      status = false;
    }

    return status;
  }
}

export default new Enotas();
